module.exports = __webpack_public_path__ + "img/lulu.0173e001.jpg";